interface Props {
  size?: "sm" | "md" | "lg" | "xl";
  // `light` renders the wordmark white for use on the dark navy sidebar.
  tone?: "brand" | "light";
}

const widthMap = {
  sm: 70,
  md: 120,
  lg: 180,
  xl: 260,
};

// Brand wordmark — paths lifted from tenants/care-by-ella/assets/brand/
// (recoloured to the Care by Ella palette). Single source of truth in SVG;
// the mobile app's Wordmark.tsx renders the same paths via react-native-svg.
export function Wordmark({ size = "md", tone = "brand" }: Props) {
  const width = widthMap[size];
  const height = (width * 82) / 180;
  const mark = tone === "light" ? "#FFFFFF" : "#7C5CFC"; // brand violet
  const accent = tone === "light" ? "#EDE9FE" : "#C9B6F2";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 180 82"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fillRule="nonzero">
        <g transform="translate(119.122 21.928)">
          <path
            fill={mark}
            d="M30.526 0C13.592.043-.251 14.013.003 30.946c.254 19.05 14.605 28.787 28.237 28.787 8.974 0 16.636-4.234 20.108-12.615v8.254a4.354 4.354 0 0 0 4.36 4.36h3.81a4.354 4.354 0 0 0 4.36-4.36v-25.06C60.836 11.981 48.39-.085 30.526 0zm16.636 30.692c-.338 8.975-7.747 16.299-16.763 16.256-10.16-.042-16.976-7.535-16.637-17.864.296-8.89 8-16.426 16.89-16.34 10.203.041 16.891 7.534 16.51 17.948z"
          />
          <circle fill={accent} cx="27.52" cy="32.259" r="5.419" />
        </g>
        <path
          fill={mark}
          d="M0 51.773c0-17.272 12.658-29.93 30.607-29.93 17.949 0 30.353 12.658 30.353 29.93v.466a4.354 4.354 0 0 1-4.36 4.36H14.35c1.821 8.298 8.171 12.658 16.214 12.658 5.377 0 9.483-1.355 12.362-4.149.804-.804 1.905-1.227 3.048-1.227h5.207c3.64 0 5.672 4.19 3.429 7.07-5.334 6.688-13.759 10.752-24.003 10.752C12.657 81.66 0 69.003 0 51.773zm46.482-6.096C44.28 38.1 38.1 34.29 30.607 34.29c-7.705 0-13.674 3.894-15.875 11.387h31.75zM88.645 77.342c0 2.794-2.624 4.869-5.291 4.191-3.853-.973-6.477-2.878-8.086-4.572-4.826-4.995-4.995-11.599-4.995-12.996V4.318C70.273 1.948 72.22 0 74.59 0h5.63c2.37 0 4.318 1.947 4.318 4.318v59.901c0 .424.17 1.524.635 2.37.127.255.339.636.974.932 1.481.72 2.497 2.16 2.497 3.81v6.011zM113.283 77.342c0 2.794-2.624 4.869-5.291 4.191-3.853-.973-6.477-2.878-8.086-4.572-4.826-4.995-4.995-11.599-4.995-12.996V4.318C94.91 1.948 96.858 0 99.229 0h5.63c2.37 0 4.318 1.947 4.318 4.318v59.901c0 .424.17 1.524.635 2.37.127.255.339.636.974.932 1.481.72 2.497 2.16 2.497 3.81v6.011z"
        />
      </g>
    </svg>
  );
}
